import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<StandardRecordDisciplineListQueryParams>('standard-record-discipline');

export type StandardRecordDisciplineListQueryParams = Parameters<typeof SSF.api.standardRecordsRecordDisciplineList>[0];

export function useStandardRecordDisciplineListQuery(params?: StandardRecordDisciplineListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.standardRecordsRecordDisciplineList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}
